var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{attrs:{"aria-label":"Page navigation example "}},[_c('ul',{staticClass:"pagination justify-content-center",staticStyle:{"margin":"5px"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }